window.registerNewUser = function(){
    let formValues = $('#register_form').serialize();
    $('#register_form .error-text').hide();
    $('#register_form .error-text');
    $('#register_loading_spinner').show();
    $('#register_form').hide();

    setTimeout(function() {
        axios.post(routes.ClientAdminRegister, formValues)
        .then(function(response){        
            $('#register_loading_spinner').hide();
            $('#register_success').html(response.data.message).show();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'sign_up',
                'user_id': response.data.user_id,
                'user_email': response.data.user_email,
            });
        }).catch(function(errors){
            if(errors.response.status == 422){
                $('#register_loading_spinner').hide();
                $('#register_form').show();
                $.each(errors.response.data.errors, function (className, error) { 
                    $(`#register_form .${className}`).text(error).show();
                });
            } else{
                $('#register_loading_spinner').hide();
                $('#register_success').html(translations.Error).show();
            }           
        }); 
    }, 1000);    
}